import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card,CardFooter } from 'react-bootstrap';
import dayjs from 'dayjs';
import { setNotification, clearNotification, getNotifications, fetchNewNotifications, clearFcmNotification } from "../../slices/notificationReducer";
import Base from '../Base';
import { setSelectedMonthYear } from "../../slices/commonReducer";
import Loader from './Loader';
import { FaArrowLeft } from 'react-icons/fa';
import PaginationComponent from './Pagination';


const NotificationPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [current_page, setCurrentPage] = useState(1);
    const { notification,totalCount, notificationList, isNotificationRoute, notificationUrl, loading: NotificationLoading, latestNotificationId, newNotificationFound, fcmNotificationReceived } = useSelector((state) => state.notification);
    const PER_PAGE = 25;
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        if (notificationList?.length)
            setNotifications(notificationList);
    }, [notificationList]);

    useEffect(() => {
        if (isNotificationRoute) {
            navigate(notificationUrl);
        }
    }, [isNotificationRoute, navigate, notificationUrl]);

    useEffect(() => {
        dispatch(getNotifications({ page: current_page }));
    }, [dispatch, current_page]);

    useEffect(() => {
        if (newNotificationFound) {
            // You might want to show a toast here if needed
            dispatch(getNotifications({ page: current_page }));
        }
        dispatch(clearNotification());
    }, [newNotificationFound, dispatch, current_page]);

    // Handlers moved from Header component
    const handleNotificationClick = async (notification) => {
        dispatch(setSelectedMonthYear({
            month: notification?.params?.month,
            year: notification?.params?.year
        }));
        dispatch(setNotification(notification));
    };

    const handleBackToHome = () => {
        navigate(-1);
    };

    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    return (
        <Base sticky_footer={false} hideDatepicker={true}>
            {NotificationLoading ? (
                <Loader />
            ) : (
                <>
                    <Container fluid>
                        <Row className="mb-4">
                            <Col>
                                <div className="d-flex flex-column align-items-start">
                                    <button
                                        variant="link"
                                        className="text-primary d-flex align-items-center gap-2 p-0 mb-2 transition-transform duration-200 hover:scale-105"
                                        onClick={handleBackToHome}
                                        style={{ fontSize: "16px", textDecoration: "none", background: "none", border: "none" }}

                                    >
                                        <FaArrowLeft size={14} /> Back
                                    </button>

                                    <h1 className="m-0 text-[28px] font-bold text-gray-800">Notifications</h1>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="pa-bento-box pa-bento-box-7 mb-3">
                                            <div className="notification-details pt-3">
                                                {!notifications?.length && (
                                                    <>
                                                        {NotificationLoading ? (
                                                            <div className="text-center py-4">
                                                                <p>Loading notifications...</p>
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-4">
                                                                <p>No new notifications at the moment</p>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {notifications?.map((notification, index) => (
                                                    <div
                                                        key={index}
                                                        className="media align-items-center mb-3 border-b border-gray-300 p-3 rounded bg-light"
                                                    >
                                                        <div className="media-body">
                                                            <div className="media justify-content-between">
                                                                <div className="w-100">
                                                                    <h6 className="mb-2">
                                                                        <Link
                                                                            to="#"
                                                                            onClick={() => handleNotificationClick(notification)}
                                                                            className="text-decoration-none"
                                                                        >
                                                                            {notification.title}
                                                                        </Link>
                                                                    </h6>
                                                                    <p className="mb-1 pa-p-d-small text-muted">
                                                                        {notification.content}
                                                                    </p>
                                                                    <p className="mb-0 pa-p-d-small italic text-secondary">
                                                                        {dayjs(notification?.created_time_formatted).format('DD-MM-YYYY hh:mm A')}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Card.Body>
                                    <CardFooter className="border-0">
                                        <div className="d-flex justify-content-center">
                                            {totalCount > PER_PAGE && (
                                                <PaginationComponent
                                                    total_count={totalCount}
                                                    current_page={current_page}
                                                    handleOnClick={handlePagination}
                                                    per_page={PER_PAGE}
                                                />
                                            )}
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </>
            )}
        </Base>
    );
};

export default NotificationPage;